<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-transparent md-absolute"
    :color-on-scroll="colorOnScroll"
  >
    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start">
        <a href="/wap">
          <img
            height="50px"
            width="auto"
            :src="bg.logo"
            alt=""
            style="width: 100%; max-height: 45px"
          />
        </a>
      </div>
      <div class="lang-mobile">
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            <flag :iso="locale || 'vn'" v-bind:squared="false" />
            <span class="text-lang">{{ locale || "vn" }}</span>
            <i class="el-icon-arrow-down el-icon--right white-color"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="lang in languages"
              :key="lang.title"
              :value="lang.language"
              :command="lang.language"
            >
              <flag :iso="lang.flag" v-bind:squared="false" />
              <span class="text-lang-item">{{
                lang.flag
              }}</span></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()"
        >
          <span
            :style="{ color: `${bg.c_menu_header} !important` }"
            class="icon-bar "
          ></span>
          <span
            :style="{ color: `${bg.c_menu_header} !important` }"
            class="icon-bar"
          ></span>
          <span
            :style="{ color: `${bg.c_menu_header} !important` }"
            class="icon-bar"
          ></span>
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section-start="false">
              <!-- Here you can add your items from the section-start of your toolbar -->
            </mobile-menu>
            <md-list>
              <md-list-item @click="toggleNavbarMobile" href="/wap/hot-deal">
                <p>{{ $t("titleHotDeal") }}</p>
              </md-list-item>

              <md-list-item @click="toggleNavbarMobile" href="/wap/top-course">
                <p>{{ $t("titleTop10") }}</p>
              </md-list-item>
              <md-list-item
                @click="toggleNavbarMobile"
                href="/wap/good-yard-area/1"
              >
                <p>{{ $t("titleMenuArea") }}</p>
              </md-list-item>
              <!-- <md-list-item @click="toggleNavbarMobile" href="#/blog">
              <p>BLOG</p>
            </md-list-item> -->
              <md-list-item
                @click="toggleNavbarMobile"
                href="/wap/history-booked"
                v-if="!showLogin"
              >
                <p>{{ $t("history") }}</p>
              </md-list-item>
              <md-list-item
                @click="toggleNavbarMobile"
                v-if="!showLogin"
                href="#"
              >
                <p>vID{{ admin.id_display || admin.vga }}</p>
              </md-list-item>
              <md-list-item class="lang-pc">
                <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    <flag :iso="locale || 'vn'" v-bind:squared="false" />
                    <span class="text-lang">{{ locale || "vn" }}</span>
                    <i
                      class="el-icon-arrow-down el-icon--right white-color"
                    ></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="lang in languages"
                      :key="lang.title"
                      :value="lang.language"
                      :command="lang.language"
                    >
                      <flag :iso="lang.flag" v-bind:squared="false" />
                      <span class="text-lang-item">{{
                        lang.flag
                      }}</span></el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </md-list-item>
            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import MobileMenu from "@/layout/MobileMenu";
import { getToken, setupLoginWap } from "@/utils/auth.js";
import i18n from "@/plugins/i18n";
import {
  getBackGround,
  getInfo,
  setFlag,
  setLanguage
} from "../../utils/wapAuth";

export default {
  components: {
    MobileMenu
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info"
        ].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    },
    logo: {
      default: require("@/assets/img/logo/W_Booking_white.png")
    }
  },
  data() {
    return {
      bg: getBackGround(),
      extraNavClasses: "",
      toggledClass: false,
      admin: getToken(),
      languages: [
        { flag: "us", language: "en", title: "English" },
        { flag: "vn", language: "vi", title: "Tiếng Việt" },
        { flag: "th", language: "th", title: "Thái Lan" }
      ],
      locale: localStorage.getItem("flag")
    };
  },
  created() {
    setupLoginWap(this);
  },
  computed: {
    showDownload() {
      const excludedRoutes = ["login", "landing", "profile"];
      return excludedRoutes.every(r => r !== this.$route.name);
    },
    showLogin() {
      return !getInfo();
      // return !window.localStorage.getItem("token");
    }
  },
  methods: {
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    // handleLogin() {
    //   this.toggleNavbarMobile();
    //   this.$store.dispatch("showLoginDialog");
    // },
    // handleLogout() {
    //   this.toggleNavbarMobile();
    //   window.localStorage.clear("info");
    //   window.location.reload();
    // },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },
    handleCommand(command) {
      i18n.locale = command;
      // localStorage.setItem("language", command);
      setLanguage(command);
      if (command === "en") {
        this.locale = "us";
        // localStorage.setItem("flag", "us");
        setFlag("us");
      } else if (command === "vi") {
        this.locale = "vn";
        // localStorage.setItem("flag", "vn");
        setFlag("vn");
      } else {
        this.locale = command;
        // localStorage.setItem("flag", command);
        setFlag("command");
      }
    }
  },
  mounted() {
    // document.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    // document.removeEventListener("scroll", this.scrollListener);
  }
};
</script>

<style scoped>
.lang-mobile {
  display: none;
}
.md-list-item .md-list-item-content p {
  color: v-bind("bg.c_menu_header");
  font-weight: 500;
}

.text-lang {
  padding-left: 4px;
  font-weight: 500;
  text-transform: uppercase;
}
.text-lang-item {
  padding-left: 4px;
  text-transform: uppercase;
}
.white-color {
  color: v-bind("bg.c_menu_header");
}
@media (max-width: 991px) {
  .md-collapse-lateral .md-collapse::before {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    display: block;
    background-color: #ffff;
    content: "";
  }
}
@media screen and (min-width: 0px) and (max-width: 980px) {
  .md-collapse::before {
    position: fixed;
    display: block;
    top: 0;
    height: 100vh;
    width: 230px !important;
    right: 0;
    left: auto;
    z-index: 1032;
    visibility: visible;
    background-color: v-bind("bg.c_header") !important;
    overflow-y: visible;
    border-top: none;
    text-align: left;
    padding-right: 0px;
    padding-left: 0;
  }
  .lang-mobile {
    background: #0000 !important ;
    display: block;
    padding-left: 25px;
  }
  .lang-pc {
    display: none;
  }
}
</style>
